export default {
    apiKey: "AIzaSyBAkrntp3VcKkrP3iQI_87n9qLzIHsSWPU",
    authDomain: "thomas-klubert.firebaseapp.com",
    databaseURL: "https://thomas-klubert.firebaseio.com",
    projectId: "thomas-klubert",
    storageBucket: "thomas-klubert.appspot.com",
    messagingSenderId: "626343638762"
}
